import * as React from "react";
const SvgFiRrHockeyStickPuck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hockey-stick-puck_svg__a)">
      <path
        fill="#062147"
        d="M23.461.112a1 1 0 0 0-1.349.427l-8.543 16.46H3.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h5.044a5.98 5.98 0 0 0 5.326-3.236L23.888 1.46a1 1 0 0 0-.427-1.348M12.095 19.84a3.99 3.99 0 0 1-3.551 2.158H3.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5h9.032l-.438.842zM24 22.999a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hockey-stick-puck_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHockeyStickPuck;
